import estimates from './varietyEstimates'
import CRUD from '../masterData/genericCRUD'

const route = 'grower_estimates'

/**
 * @param {import("axios").AxiosInstance} instance
 */

export default function growerEstimates(instance) {
	return {
		...CRUD(instance, route),
		varietyEstimates: estimates(instance),

		/**
		 *
		 * @param {object} config
		 */
		getFarms: (config = {}) => {
			return instance.get(`${route}/farms`, config)
		}
	}
}
